import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_93f50fc4: FaireBrandEntity = {
  token: "b_93f50fc4",
  type: "brand",
  name: "Tiro Tiro Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ea944965205816ce2785f659eb79bb6edc64e188455fb411f8487500230fb42.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e8833c677e31418d44bcca70c114ac34b966d08405a1ee3ddee417911e63d727.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3ea944965205816ce2785f659eb79bb6edc64e188455fb411f8487500230fb42.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e8833c677e31418d44bcca70c114ac34b966d08405a1ee3ddee417911e63d727.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "TIRO TIRO IS A WELL CONSIDERED LINE OF JEWELRY DESIGNED BY TERESA ROBINSON. \nInformed by traditional craft practices and almost 20 years of jewelry-making experience, we design enduring, covetable pieces for everyday use and enjoyment. We believe in the power of beautiful objects to inspire, delight and bring joy to the beholder, and aim to make work that does just that. Tiro comes from the latin word for a beginner or novice. To that end, Tiro Tiro embraces an era of experimentation and improvisation, drawing from our years of practice and honed expertise and then making things up as we go.\n\nTeresa Robinson is the daughter of two artists and a native of the Pacific Northwest. When she was 20 years old and studying fine art at Hampshire College, she spent 6 months in San Miguel de Allende, Mexico. There, she took a jewelry class on a whim and fell in love with metal smithing. She has launched 3 successful jewelry lines over the past twenty years (Smallthings in 2001, Stone & Honey in 2008 and Tiro Tiro in 2013). She lives in a little grey house in Portland, Oregon with her daughter and 2 precocious chickens.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:05.589Z",
    importedBy: "entity-db-cli",
  },
};
